import axios from 'axios';
import { logAxiosError } from '@/lib/errorLogger';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('werner_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('werner_token');
      if (window.location.pathname !== '/auth' && window.location.pathname !== '/flow') {
        window.location.href = '/auth';
      }
    }
    logAxiosError(error);
    return Promise.reject(error);
  }
);

export default api;
